class TableModels_mok {
  static getModelsList(text, pageNumber) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({
          models: [
            {
              id: "1",
              modelname: "دما، رطوبت",
              seriname: "AA",
              environment: "محیط خارجی",
              useType: "صنعتی",
              testType: "کیفیت سنج",
              countdevice: "23 دستگاه",
              sensore:[
                {id:'1', username:"دما", jsonname:"TEMP",measurunit:"",maxIndex:'0',minIndex:"100",maxamount:"55",minamount:'-16'},
                {id:'2', username:"رطوبت", jsonname:"HUMI",measurunit:"",maxIndex:'0',minIndex:"100",maxamount:"200",minamount:'0'},
            ]
            },
            {
              id: "2",
              modelname: "کیفیت محیط داخلی",
              seriname: "CC",
              environment: "محیط داخلی",
              useType: "خانگی",
              testType: "مقدار سنج",
              countdevice: "54 دستگاه",
              sensore:[
                {id:'1', username:"دما", jsonname:"TEMP",measurunit:"",maxIndex:'0',minIndex:"100",maxamount:"55",minamount:'-16'},
                {id:'2', username:"رطوبت", jsonname:"HUMI",measurunit:"",maxIndex:'0',minIndex:"100",maxamount:"200",minamount:'0'},
            ]
            },
            {
              id: "3",
              modelname: "دی اکسید کربن",
              seriname: "DD",
              environment: "محیط داخلی",
              useType: "صنعتی",
              testType: "مقدار سنج",
              countdevice: "143 دستگاه",
              sensore:[
                {id:'1', username:"دما", jsonname:"TEMP",measurunit:"",maxIndex:'0',minIndex:"100",maxamount:"55",minamount:'-16'},
                {id:'2', username:"رطوبت", jsonname:"HUMI",measurunit:"",maxIndex:'0',minIndex:"100",maxamount:"200",minamount:'0'},
            ]
            },
            {
              id: "4",
              modelname: "دما، رطوبت",
              seriname: "CC",
              environment: "محیط خارجی",
              useType: "صنعتی",
              testType: "کیفیت سنج",
              countdevice: "57 دستگاه",
              sensore:[
                {id:'1', username:"دما", jsonname:"TEMP",measurunit:"",maxIndex:'0',minIndex:"100",maxamount:"55",minamount:'-16'},
                {id:'2', username:"رطوبت", jsonname:"HUMI",measurunit:"",maxIndex:'0',minIndex:"100",maxamount:"200",minamount:'0'},
            ]
            },
            {
              id: "5",
              modelname: "کیفیت محیط داخلی",
              seriname: "DD",
              environment: "محیط داخلی",
              useType: "صنعتی",
              testType: "مقدار سنج",
              countdevice: "23 دستگاه",
              sensore:[
                {id:'1', username:"دما", jsonname:"TEMP",measurunit:"",maxIndex:'0',minIndex:"100",maxamount:"55",minamount:'-16'},
                {id:'2', username:"رطوبت", jsonname:"HUMI",measurunit:"",maxIndex:'0',minIndex:"100",maxamount:"200",minamount:'0'},
            ]
            },
            {
              id: "6",
              modelname: "دی اکسید کربن",
              seriname: "CC",
              environment: "محیط داخلی",
              useType: "صنعتی",
              testType: "کیفیت سنج",
              countdevice: "91 دستگاه",
              sensore:[
                {id:'1', username:"دما", jsonname:"TEMP",measurunit:"",maxIndex:'0',minIndex:"100",maxamount:"55",minamount:'-16'},
                {id:'2', username:"رطوبت", jsonname:"HUMI",measurunit:"",maxIndex:'0',minIndex:"100",maxamount:"200",minamount:'0'},
            ]
            },
            {
              id: "7",
              modelname: "دما، رطوبت",
              seriname: "DD",
              environment: "محیط داخلی",
              useType: "خانگی",
              testType: "مقدار سنج",
              countdevice: "57 دستگاه",
              sensore:[
                {id:'1', username:"دما", jsonname:"TEMP",measurunit:"",maxIndex:'0',minIndex:"100",maxamount:"55",minamount:'-16'},
                {id:'2', username:"رطوبت", jsonname:"HUMI",measurunit:"",maxIndex:'0',minIndex:"100",maxamount:"200",minamount:'0'},
            ]
            },
            {
              id: "8",
              modelname: "کیفیت محیط داخلی",
              seriname: "CC",
              environment: "محیط خارجی",
              useType: "صنعتی",
              testType: "کیفیت سنج",
              countdevice: "143 دستگاه",
              sensore:[
                {id:'1', username:"دما", jsonname:"TEMP",measurunit:"",maxIndex:'0',minIndex:"100",maxamount:"55",minamount:'-16'},
                {id:'2', username:"رطوبت", jsonname:"HUMI",measurunit:"",maxIndex:'0',minIndex:"100",maxamount:"200",minamount:'0'},
            ]
            },
            {
              id: "9",
              modelname: "دی اکسید کربن",
              seriname: "CC",
              environment: "محیط داخلی",
              useType: "صنعتی",
              testType: "مقدار سنج",
              countdevice: "34 دستگاه",
              sensore:[
                {id:'1', username:"دما", jsonname:"TEMP",measurunit:"",maxIndex:'0',minIndex:"100",maxamount:"55",minamount:'-16'},
                {id:'2', username:"رطوبت", jsonname:"HUMI",measurunit:"",maxIndex:'0',minIndex:"100",maxamount:"200",minamount:'0'},
            ]
            },
            {
              id: "10",
              modelname: "دما، رطوبت",
              seriname: "AA",
              environment: "محیط خارجی",
              useType: "صنعتی",
              testType: "کیفیت سنج",
              countdevice: "58 دستگاه",
              sensore:[
                {id:'1', username:"دما", jsonname:"TEMP",measurunit:"",maxIndex:'0',minIndex:"100",maxamount:"55",minamount:'-16'},
                {id:'2', username:"رطوبت", jsonname:"HUMI",measurunit:"",maxIndex:'0',minIndex:"100",maxamount:"200",minamount:'0'},
            ]
            },
          ],
          countAll: 14,
        });
      }, 1000);
    });
  }
  static delete(id) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({
          status: {
            code: "1",
            massage: "با موفقیت حذف شد",
          },
        });
      }, 1000);
    });
  }
}
export { TableModels_mok };
